module.exports = __webpack_public_path__ + "img/struct_tag.ce137ff6.png";